import { render, staticRenderFns } from "./OfficeLayout.vue?vue&type=template&id=810f9936&scoped=true&functional=true&"
import script from "./OfficeLayout.vue?vue&type=script&lang=js&"
export * from "./OfficeLayout.vue?vue&type=script&lang=js&"
import style0 from "./OfficeLayout.vue?vue&type=style&index=0&id=810f9936&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "810f9936",
  null
  
)

export default component.exports